var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['miniliink', { inApp: _vm.$root.$data.isApp || this.$root.miniprogram }]},[_c('div',{staticClass:"miniliink-box"},[(_vm.img)?_c('img',{staticClass:"pxind",attrs:{"src":_vm.img,"alt":""}}):_vm._e(),(_vm.apiId)?_c('button',{on:{"click":_vm.gostudy}},[_vm._v("前往小程序")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }